// Il tema: chiaro, scuro, o quello che dice il sistema.
//
// Tre stati e non due. «Come il sistema» non e' un ripiego: e' la scelta di
// chi vuole che l'app segua il resto della macchina quando cala la sera — e se
// la togliessimo, quella persona dovrebbe cambiare tema a mano due volte al
// giorno.

const MEMORIA = "md2pdf-webui:tema";

export type Tema = "sistema" | "chiaro" | "scuro";


export function temaSalvato(): Tema
{
    const letto = localStorage.getItem(MEMORIA);
    return letto === "chiaro" || letto === "scuro" ? letto : "sistema";
}


export function applicaTema(tema: Tema): void
{
    localStorage.setItem(MEMORIA, tema);

    // `data-theme` sulla radice: il CSS ha gia' le due palette, e questo
    // attributo decide quale vince sul `prefers-color-scheme`.
    if (tema === "sistema") { document.documentElement.removeAttribute("data-theme"); }
    else { document.documentElement.setAttribute("data-theme", tema === "scuro" ? "dark" : "light"); }
}


/** Quello che si vede DAVVERO adesso: serve all'editor, che vuole sapere il colore, non la preferenza. */
export function temaEffettivo(tema: Tema): "chiaro" | "scuro"
{
    if (tema !== "sistema") { return tema; }
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "scuro" : "chiaro";
}
